import React, { useState } from 'react';

// Hard-coded sample documents (2026-07-26: no in-app upload/replace).
// Redacted sample files live in portal/public/doc-samples/ and ship with the
// build; kinds without a file yet simply don't render a chip. To change a
// sample, replace the file in that folder and rebuild.
const SAMPLE_URLS = {
    residence_visa: '/doc-samples/residence-visa.jpg',
    cancellation_paper: '/doc-samples/cancellation-paper.jpg',
    tourist_entry_permit: '/doc-samples/tourist-entry-permit.jpg',
    labour_card: '/doc-samples/labour-card.jpg',
};

// Option rows + sample chips for a document tile.
// - `options`: [{ kind, text }] — each case on its own line ("Already on HHC
//   company ID? Upload the residence visa.") with its sample chip beside it.
// - `samples`: [{ kind, label }] — bare sample chips for tiles without option
//   text (e.g. Labour card).
// "See sample" opens the bundled sample in a lightbox (image or PDF).
export default function DocSampleBlock({ options, samples }) {
    const [viewing, setViewing] = useState(null); // { title, url }

    if ((!options || options.length === 0) && (!samples || samples.length === 0)) return null;

    const chip = (kind, title) => {
        const url = SAMPLE_URLS[kind];
        if (!url) return null;
        return (
            <button type="button" className="doc-sample-chip" onClick={() => setViewing({ title, url })}>
                See sample
            </button>
        );
    };

    const isPdf = viewing && /\.pdf($|\?)/i.test(viewing.url);

    return (
        <>
            {options && options.length > 0 && (
                <ul className="doc-options">
                    {options.map((o) => (
                        <li key={o.kind}>
                            <span className="doc-option-text">{o.text}</span>
                            {chip(o.kind, o.text)}
                        </li>
                    ))}
                </ul>
            )}
            {samples && samples.length > 0 && SAMPLE_URLS[samples[0].kind] && (
                <div className="doc-samples-row">
                    {samples.map((s) => (
                        <span key={s.kind} className="doc-samples-item">
                            <span className="doc-option-text">{s.label} sample</span>
                            {chip(s.kind, `${s.label} sample`)}
                        </span>
                    ))}
                </div>
            )}

            {viewing && (
                <div className="doc-sample-overlay" onClick={() => setViewing(null)}>
                    <div className="doc-sample-panel" onClick={(e) => e.stopPropagation()}>
                        <div className="doc-sample-head">
                            <span className="doc-sample-title">{viewing.title}</span>
                            <button type="button" className="doc-sample-close" onClick={() => setViewing(null)} title="Close">×</button>
                        </div>
                        <div className="doc-sample-body">
                            {isPdf
                                ? <iframe className="doc-sample-pdf" src={viewing.url} title="Sample document" />
                                : <img className="doc-sample-img" src={viewing.url} alt="Sample document" />}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
